import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    a {
        color: ${props => props.theme.primary};
    }

    tr {
        color: ${props => props.theme.secondary};
        background-color: ${props => props.theme.tertiary};
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        box-shadow: 0 0 0 30px white inset;
    }

    input::-ms-reveal, input::-ms-clear {
        display: none;
    }

    @media print {
        html,
        body {
            background: #fff;
            margin: 0;
            padding: 0;
            font-size: 12px;
        }
    }

    @media only screen and (max-width: ${props =>
        props.theme.maxWidth}) and (orientation: landscape) {
        body {
            text-size-adjust: 100%;
        }
    }
`;
